import { getTherapistSlots } from "@/lib/therapist-scheduling/api";
import type { TherapistSlotsResponse } from "@/lib/therapist-scheduling/types";
import { useAbortableResource } from "./use-abortable-resource";

/**
 * Fetches one therapist's rich slots for a date (SLOT_SOURCE.PER_THERAPIST_DETAIL).
 * §8 enabled gate: therapistId && date.
 */
export function useTherapistSlots(
	therapistId: string | null | undefined,
	date: string | null | undefined,
	// Admin-board only (see TherapistSlotsParams): a booking path must leave this
	// off so out-of-contract dates stay unoffered.
	{ bypassContractCheck = false }: { bypassContractCheck?: boolean } = {},
) {
	const enabled = !!therapistId && !!date;

	return useAbortableResource<TherapistSlotsResponse>(
		(signal) =>
			getTherapistSlots(
				therapistId as string,
				{ date: date as string, bypass_contract_check: bypassContractCheck },
				{ signal },
			),
		{
			enabled,
			key: JSON.stringify({ therapistId, date, bypassContractCheck }),
		},
	);
}
